<template>
    <div v-if="protocol" class="w-100 pa-1 lm-border ">
        <d-unit-select-dialog
            v-model      = "showUnitSelect"
            :title       = "$t('todo.guard.assign.title')"
            :text        = "$t('todo.guard.assign.text')"
            :store-label = "$t('todo.guard.assign.label')"
            :customer    = "{
                id: protocol.customerId
            }"
            @selected    = "onSelected"
        />

        <div class="pa-1" >
            <div class="v-flex">
                <div class="text-primary">
                    {{ protocol.factoryNo }}
                </div>
                <v-spacer />
                <div class="">
                    {{ formatDate (protocol.inspectionDate) }}
                </div>

                <div style="margin-top: 0" class="v-flex">
                    <p-inc-guard-protocol-check-list
                        class     = "pl-2"
                        :protocol = "protocol"
                        :valid    = "protocol.result === 'ok'"
                    />
                    <c-toolbar-button
                        v-if="!protocol.unit && protocol.customerId"
                        icon    = "mdi-connection"
                        size    = "18"
                        color   = "primary"
                        tooltip = "Anlage zuordnen"
                        @click  = "onAssign"
                    />
                    <c-toolbar-button
                        icon    = "mdi-delete"
                        size    = "22"
                        color   = "error"
                        tooltip = "Protokoll löschen"
                        @click  = "onDelete"
                    />
                </div>
            </div>
            <div style="font-size: 12px">
                {{ protocol.street }}, {{ protocol.city }}
            </div>

            <div class="v-flex">
                <div
                    v-if="!protocol.unit && protocol.customerId"
                    class="error--text"
                    style="font-size: 12px"
                >
                    unbekannte Anlage
                </div>
                <div
                    v-if="!protocol.unit && !protocol.customerId"
                    class="error--text"
                    style="font-size: 12px"
                >
                    unbekannter Kunde
                </div>
                <v-spacer />
                <div
                    style="font-size: 12px"
                >
                    {{ protocol.customerName }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Core                       from "@/modules/core/service/Core.js";
import PIncGuardProtocolCheckList from "@/modules/inc/todos/components/private/PIncGuardProtocolCheckList.vue";
import DUnitSelectDialog          from "@/modules/msd/unit/components/controlls/DUnitSelectDialog.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

export default {
    name: "PIncGuardProtocolFailedCard",
    components: {
        CToolbarButton,
        DUnitSelectDialog,
        PIncGuardProtocolCheckList
    },

    props: {
        protocol: {
        },
    },

    data: () => ({
        entries: [],
        showUnitSelect: false,
    }),

    computed: {
        unit () {
            return this.protocol.unit;
        },
    },

    methods: {
        formatDate (value) {
            return Core.format.date.display(value)
        },

        onAssign () {
            this.showUnitSelect = true;
        },

        onSelected (unit) {
            this.$emit("assign", {
                protocol: this.protocol,
                unit    : unit
            });

            this.showUnitSelect = false;
        },

        onDelete () {
            Core.message.confirm(
                this,
                this.$t('todo.guard.delete.query'),
                this.$t('todo.guard.delete.text'),
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    this.$emit("delete", this.protocol);
                });
        }
    }
}
</script>

<style scoped>

.button-style {
    min-width: 22px!important;
    width: 22px!important;
    height: 22px!important;
    margin-top: 0
}

</style>